export const routeEndpoints = {
  landing: "/",
  orders: "/orders",
  order: "/order",
  orderDetails: "/order-details",
  shippingStatus: "/shipping-status",
  shippingLabel: "/shipping-label",
  reviewPurchase: "/review-purchase",
  authorize: "/authorize",
  login: "/login",
  signup: "/signup",
  verifyEmail: "/verify-email",
  forgotPassword: "/forgot-password",
  verifyResetCode: "/verify-reset-code",
  resetPassword: "/reset-password",
  settings: "/settings",
};
